import store from '../../store/index'
let wsUrl=""
const connectSocket=(url)=>{
  wsUrl=url;
	try {
	// 创建一个WebSocket实例 ws
	window.webSocket = new WebSocket(url)
	// ws 初始化一些事件
	init();
	} catch(e) {
	console.log(' 连接失败');
	// 连接失败后重连
	reconnect(url);
	}
}
//判断是否链接成功
const sendWebSocket=()=>{
	if(window.webSocket.readyState==window.webSocket.OPEN){
		let token = store.state.userLoginMessage.token;
		let data = { type:10000, token:token};
		let json = JSON.stringify(data);
		window.webSocket.send(json);
		// 连接打开后发送心跳
		heartCheck.start();0
	}else{
		setTimeout(function (){
			sendWebSocket();
		},1000);
	}
}
const init=()=>{
	// ws 监听onclose事件
	window.webSocket.onclose = function (event) {
		if(!event.wasClean)reconnect(wsUrl);
		// close事件触发后重连
	};

	window.webSocket.onerror = function() {
		console.log('发生异常了');
		// 连接发生异常需要重连
		reconnect(wsUrl);
	};
	// 连接打开的时候触发
	window.webSocket.onopen = function () {
		sendWebSocket();
	};
	// 收到服务端消息的时候触发
	window.webSocket.onmessage = function (evt) {
	let data = JSON.parse(evt.data);
	console.log('接收到消息');
      //0	正常,41000 token不存在,41001 连接已断开
      if (data.code === 41001) {
        reconnect(wsUrl);
        return
      }
      if (data.type <10000) {
		data.data.type=data.type;
		console.log(data)
        store.commit('UPDATENEWNOTIFY', data.data)
      }
		//拿到任何消息都说明当前连接是正常的，然后接着继续发送心跳
		heartCheck.start();
	}
}
var lockReconnect = false,tt=false;//避免重复连接
function reconnect(url) {
	if(lockReconnect) {
	return;
	};
	lockReconnect = true;
	//没连接上会一直重连，设置延迟避免请求过多
	tt && clearTimeout(tt);
	tt = setTimeout(function () {
  lockReconnect = false;
  connectSocket(url);
	}, 4000);
}
var heartCheck = {
	timeout: 50000, //每隔50秒发送心跳
	severTimeout: 5000, //服务端超时时间
	timeoutObj: null,
	serverTimeoutObj: null,
	start: function(){
	var _this = this;
	this.timeoutObj && clearTimeout(this.timeoutObj);
	this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
	this.timeoutObj = setTimeout(function(){
    let data = {type:10001};
    let json = JSON.stringify(data);
		//这里发送一个心跳，后端收到后，返回一个心跳消息，
		//onmessage拿到返回的心跳就说明连接正常
		window.webSocket.send(json); // 心跳包
		//计算答复的超时时间
		_this.serverTimeoutObj = setTimeout(function() {
		// 超时后手动关闭会触发onclose事件，然后就会重连
		window.webSocket.close();
		}, _this.severTimeout);
		}, this.timeout)	
   	}
}
export default connectSocket
